export default "__VITE_ASSET__QpFMopIg__"